import React from 'react';
import { Code2, FileCode, FolderGit2, GitPullRequest, Lightbulb } from 'lucide-react';
import { CODE_STATS } from '../../data/config';
import WidgetContainer from '../WidgetContainer';

const CodeStatistics = ({ delay = 0 }) => {
  return (
    <WidgetContainer size="2x2" delay={delay}>
      <div className="widget-header">
        <h3>Code Statistics</h3>
        <Code2 className="widget-icon" />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="bg-coffee-700/20 rounded-lg p-4 hover:bg-coffee-700/30 transition-colors">
          <div className="flex items-center gap-3 mb-2">
            <div className="p-2 bg-coffee-600/30 rounded-lg">
              <FileCode className="w-5 h-5 text-coffee-300" />
            </div>
            <div>
              <div className="text-2xl font-bold text-cream-100">{CODE_STATS.linesWritten}</div>
              <div className="text-xs text-coffee-200">Lines Written</div>
            </div>
          </div>
        </div>

        <div className="bg-coffee-700/20 rounded-lg p-4 hover:bg-coffee-700/30 transition-colors">
          <div className="flex items-center gap-3 mb-2">
            <div className="p-2 bg-coffee-600/30 rounded-lg">
              <Code2 className="w-5 h-5 text-coffee-300" />
            </div>
            <div>
              <div className="text-2xl font-bold text-cream-100">{CODE_STATS.languages}</div>
              <div className="text-xs text-coffee-200">Languages</div>
            </div>
          </div>
        </div>

        <div className="bg-coffee-700/20 rounded-lg p-4 hover:bg-coffee-700/30 transition-colors">
          <div className="flex items-center gap-3 mb-2">
            <div className="p-2 bg-coffee-600/30 rounded-lg">
              <FolderGit2 className="w-5 h-5 text-coffee-300" />
            </div>
            <div>
              <div className="text-2xl font-bold text-cream-100">{CODE_STATS.projects}</div>
              <div className="text-xs text-coffee-200">Projects</div>
            </div>
          </div>
        </div>

        <div className="bg-coffee-700/20 rounded-lg p-4 hover:bg-coffee-700/30 transition-colors">
          <div className="flex items-center gap-3 mb-2">
            <div className="p-2 bg-coffee-600/30 rounded-lg">
              <GitPullRequest className="w-5 h-5 text-coffee-300" />
            </div>
            <div>
              <div className="text-2xl font-bold text-cream-100">{CODE_STATS.pullRequests}</div>
              <div className="text-xs text-coffee-200">Pull Requests</div>
            </div>
          </div>
        </div>
      </div>

      {/* Fun Fact */}
      <div className="mt-4 p-3 bg-gradient-to-r from-coffee-700/30 to-coffee-600/30 rounded-lg border border-coffee-600/20">
        <div className="text-xs text-coffee-300 uppercase tracking-wider mb-1 flex items-center gap-1.5">
          <Lightbulb className="w-3.5 h-3.5 text-caramel-400" />
          Fun Fact
        </div>
        <div className="text-sm text-cream-100">
          That's enough code to circle the Earth {((847000 * 80) / 40075000).toFixed(1)} times if printed!
        </div>
      </div>
    </WidgetContainer>
  );
};

export default CodeStatistics;
